import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from "axios";
import Logo from '../components/Logo';

const capitalizeWords = (text = "") =>
  text
    .trim()
    .toLowerCase()
    .split(" ")
    .filter(Boolean)
    .map(
      word => word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(" ");

const RegisterPage = () => {
  const navigate = useNavigate();
  // const { register } = useAuth(); // No usado actualmente

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);


  const [formData, setFormData] = useState({
    brideName: '',
    brideLastName: '',
    groomName: '',
    groomLastName: '',
    email: '',
    phone: '',
    celular: '',
    ceremonyDate: '',  // ✅ Cambiar
    partyDate: '',     // ✅ Agregar
    howDidYouHear: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [success] = useState(false); // setSuccess no usado
  const [toast, setToast] = useState(null);
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

useEffect(() => {
  if (toast) {
    const duration = toast.type === "success" ? 3000 : 6000; // 3s para success, 6s para error
    
    const timer = setTimeout(() => {
      setToast(null);
    }, duration);

    return () => clearTimeout(timer);
  }
}, [toast]);
const handleSubmit = async (e) => {
  e.preventDefault();
  if (loading) return;
  setLoading(true);

  const todayStr = new Date().toISOString().split("T")[0];

  const payload = {
    ...formData,
    brideName: capitalizeWords(formData.brideName),
    brideLastName: capitalizeWords(formData.brideLastName),
    groomName: capitalizeWords(formData.groomName),
    groomLastName: capitalizeWords(formData.groomLastName),
    email: formData.email.trim().toLowerCase(),
    phone: formData.phone.trim(),
    celular: formData.celular.trim(),
    message: formData.message.trim(),
  };

  const required = [
    ["brideName", "Nombre Novia/o 1"],
    ["brideLastName", "Apellido Novia/o 1"],
    ["groomName", "Nombre Novia/o 2"],
    ["groomLastName", "Apellido Novia/o 2"],
    ["email", "Email"],
    ["ceremonyDate", "Fecha de la ceremonia"],
    ["howDidYouHear", "¿Cómo nos conociste?"],
  ];

  for (const [key, label] of required) {
    if (!payload[key] || !String(payload[key]).trim()) {
      setToast({ type: "error", message: `${label} es obligatorio.` });
      setLoading(false);
      return;
    }
  }

  // Validación de fechas
  if (payload.ceremonyDate < todayStr) {
    setToast({
      type: "error",
      message: "La fecha de la ceremonia no puede ser en el pasado.",
    });
    setLoading(false);
    return;
  }

  if (payload.partyDate && payload.partyDate < todayStr) {
    setToast({
      type: "error",
      message: "La fecha de la fiesta no puede ser en el pasado.",
    });
    setLoading(false);
    return;
  }

  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.email)) {
    setToast({
      type: "error",
      message: "Ingresá un email válido.",
    });
    setLoading(false);
    return;
  }

  // ✅ DEFINIR celularDigits ACÁ DENTRO
  const celularDigits = payload.celular.replace(/\D/g, '').length;
  if (celularDigits < 8) {
    setToast({
      type: "error",
      message: "El celular debe tener al menos 8 dígitos.",
    });
    setLoading(false);
    return;
  }

  try {
      // console.log('📤 Payload a enviar:', JSON.stringify(payload, null, 2));

    const { data } = await axios.post(
      "https://sd-register-couple-336444799661.europe-west1.run.app",
      payload,
      { headers: { "Content-Type": "application/json" } }
    );

    if (data?.success) {
      setToast({
        type: "success",
        message: "¡Mensaje enviado con éxito! Te contactamos en breve 💝",
      });
      setTimeout(() => navigate("/"), 4000);
    } else {
      throw new Error("Unexpected response");
    }
  } catch (err) {
  //   console.error("❌ Register error:", err);
  // console.error("❌ Response data:", err.response?.data);
  // console.error("❌ Status:", err.response?.status);

  // ✅ Mostrar el error específico del backend
 const backendError = err.response?.data?.error;
  
  let userMessage = "Hubo un problema al enviar el formulario. Por favor, intentá nuevamente.";
  
  if (backendError) {
    if (backendError.includes("ya está asociado a una cuenta")) {
      userMessage = "Este email ya está registrado. Si olvidaste tu contraseña, recuperala desde el login.";
    } else if (backendError.includes("registro pendiente")) {
      userMessage = "Ya tenés un registro pendiente. Te contactaremos en las próximas 24 horas.";
    } else {
      userMessage = backendError;
    }
  }
      setToast({
      type: "error",
      message: userMessage,
    });
  } finally {
    setLoading(false);
  }
};


  if (success) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-accent-50 via-white to-primary-50 flex flex-col">
        <header className="bg-white shadow-sm border-b border-neutral-200 sticky top-0 z-40">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
            <Logo className="h-12 sm:h-14" />

          </div>
        </header>

        <main className="flex-1 flex items-center justify-center px-4 py-12">
          <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center animate-scale-in">
            <div className="text-6xl mb-4">✉️</div>
            <h2 className="text-3xl font-display font-bold text-neutral-900 mb-4">
              ¡Solicitud Recibida!
            </h2>
            <p className="text-neutral-600 mb-6">
              Gracias por tu interés en SobreDigital. Te enviaremos un email de confirmación
              en las próximas <strong>24 horas</strong> con los siguientes pasos para crear tu lista.
            </p>
            <p className="text-sm text-neutral-500 mb-8">
              Revisá tu casilla de correo (incluyendo spam) en breve.
            </p>
            <Link to="/" className="btn-primary inline-block">
              Volver al Inicio
            </Link>
          </div>
        </main>
      </div>
    );
  }

  // ✅ Función para formatear celular
  const handleCelularChange = (e) => {
    let value = e.target.value;

    // Limpiar: solo dígitos y +
    let cleaned = value.replace(/[^\d+]/g, '');

    // El + solo puede estar al inicio
    if (cleaned.includes('+') && !cleaned.startsWith('+')) {
      cleaned = '+' + cleaned.replace(/\+/g, '');
    }

    // Máximo un +
    const plusCount = (cleaned.match(/\+/g) || []).length;
    if (plusCount > 1) {
      cleaned = '+' + cleaned.replace(/\+/g, '');
    }

    setFormData(p => ({ ...p, celular: cleaned }));
  };

  // ✅ Validar si el celular parece válido
  const celularDigits = formData.celular.replace(/\D/g, '').length;
  const hasCelularInput = formData.celular.length > 0;
  const isCelularIncomplete = hasCelularInput && celularDigits > 0 && celularDigits < 8;
  const isCelularValid = celularDigits >= 8;

  return (
    <div className="min-h-screen bg-gradient-to-br from-accent-50 via-white to-primary-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          {/* <Link to="/" className="flex items-center space-x-2">
            <span className="text-3xl">💝</span>
            <span className="text-2xl font-script font-bold text-accent-600">
              SobreDigital
            </span>
          </Link> */}
          <Logo className="h-12 sm:h-14" />

        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-xl p-8 animate-fade-in">
          {/* Title */}
          <div className="text-center mb-8">
            <h2 className="text-3xl sm:text-4xl font-display font-bold text-neutral-900 mb-2">
              Creá tu Lista de Regalos
            </h2>
            <p className="text-neutral-600">
              Completá el formulario y nos pondremos en contacto
            </p>
          </div>

          {/* Info Banner */}
          <div className="bg-accent-50 border border-accent-200 rounded-lg p-4 mb-8">
            <p className="text-sm text-accent-900">
              <strong>📌 Recordá:</strong> Para regalar no hace falta crear una cuenta.
              {/* Simplemente buscá la lista que deseés y regalá. */}
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Novios Data */}
            <div className="space-y-4">
              <h3 className="text-xl font-display font-semibold text-neutral-900">
                Datos de los Novios
              </h3>

              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-neutral-700 mb-2">
                    Nombre Novia/o 1 *
                  </label>
                  <input
                    type="text"
                    name="brideName"
                    value={formData.brideName}
                    onChange={handleChange}
                    required
                    className="input-field"
                    placeholder="María"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-neutral-700 mb-2">
                    Apellido Novia/o 1 *
                  </label>
                  <input
                    type="text"
                    name="brideLastName"
                    value={formData.brideLastName}
                    onChange={handleChange}
                    required
                    className="input-field"
                    placeholder="González"
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-neutral-700 mb-2">
                    Nombre Novia/o 2 *
                  </label>
                  <input
                    type="text"
                    name="groomName"
                    value={formData.groomName}
                    onChange={handleChange}
                    required
                    className="input-field"
                    placeholder="Juan"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-neutral-700 mb-2">
                    Apellido Novia/o 2 *
                  </label>
                  <input
                    type="text"
                    name="groomLastName"
                    value={formData.groomLastName}
                    onChange={handleChange}
                    required
                    className="input-field"
                    placeholder="Pérez"
                  />
                </div>
              </div>
            </div>

            {/* Contact Info */}
            <div className="space-y-4 border-t border-neutral-200 pt-6">
              <h3 className="text-xl font-display font-semibold text-neutral-900">
                Información de Contacto
              </h3>

              <div>
                <label className="block text-sm font-medium text-neutral-700 mb-2">
                  Email *
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="input-field"
                  placeholder="tu@email.com"
                />
              </div>

              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-neutral-700 mb-2">
                    Teléfono
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="input-field"
                    placeholder="011 1234-5678"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-neutral-700 mb-2">
                    Celular *
                  </label>
                  <input
                    type="tel"
                    name="celular"
                    value={formData.celular}
                    onChange={handleCelularChange}
                    required
                    className="input-field"
                    placeholder="+54 11 1234-5678"
                    maxLength={16}
                  />
                  {isCelularIncomplete && (
                    <p className="text-xs text-amber-600 mt-1">
                      ⚠️ El número parece incompleto
                    </p>
                  )}
                  {isCelularValid && (
                    <p className="text-xs text-green-600 mt-1">
                      ✓ Número válido
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* Event Info */}
            <div className="space-y-4 border-t border-neutral-200 pt-6">
              <h3 className="text-xl font-display font-semibold text-neutral-900">
                Información del Evento
              </h3>

              {/* Reemplazar el input de fecha actual por estos dos */}
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-neutral-700 mb-2">
                    Fecha de la ceremonia *
                  </label>
                  <input
                    type="date"
                    name="ceremonyDate"
                    value={formData.ceremonyDate}
                    min={new Date().toISOString().split("T")[0]}
                    onChange={handleChange}
                    required
                    className="input-field"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-neutral-700 mb-2">
                    Fecha de la fiesta
                  </label>
                  <input
                    type="date"
                    name="partyDate"
                    value={formData.partyDate}
                    min={new Date().toISOString().split("T")[0]}
                    onChange={handleChange}
                    className="input-field"
                  />
                  <p className="text-xs text-neutral-500 mt-1">
                    Dejá en blanco si es el mismo día
                  </p>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-neutral-700 mb-2">
                  ¿Cómo nos conociste? *
                </label>
                <select
                  name="howDidYouHear"
                  value={formData.howDidYouHear}
                  onChange={handleChange}
                  required
                  className="input-field"
                >
                  <option value="">Seleccioná una opción</option>
                  <option value="google">Google</option>
                  <option value="instagram">Instagram</option>
                  <option value="facebook">Facebook</option>
                  <option value="amigo">Recomendación de un amigo</option>
                  <option value="otro">Otro</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-neutral-700 mb-2">
                  Mensaje (opcional)
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  className="input-field resize-none"
                  placeholder="Contanos tu consulta..."
                />
              </div>
            </div>

            {/* Submit */}
            <div className="pt-6">
              <button
                type="submit"
                disabled={loading}
                className="w-full btn-primary text-lg py-4"
              >
                {loading ? (
                  <span className="flex items-center justify-center">
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Enviando...
                  </span>
                ) : (
                  'Enviar Solicitud'
                )}
              </button>
            </div>
          </form>

          {/* Login Link */}
          <div className="mt-6 text-center border-t border-neutral-200 pt-6">
            <p className="text-neutral-600 text-sm">
              ¿Ya tenés cuenta?{' '}
              <Link to="/login" className="text-accent-600 hover:text-accent-700 font-semibold">
                Iniciá sesión
              </Link>
            </p>
          </div>
        </div>

        {/* Back to Home */}
        <div className="mt-6 text-center">
          <Link to="/" className="text-neutral-600 hover:text-neutral-900 text-sm font-medium">
            ← Volver al inicio
          </Link>
        </div>
      </main>

      {toast && (
        <div
          className={`fixed top-6 right-6 z-50 px-6 py-4 rounded-xl shadow-lg text-white animate-fade-in
      ${toast.type === "success" ? "bg-green-600" : "bg-red-600"}`}
        >
          {toast.message}
        </div>
      )}

    </div>


  );
};

export default RegisterPage;
